module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"save":"Save","cancel":"Cancel","interviewQuestionList":"Interview questions list","returnToMaster":"Back to the Job question selection"}}')
  delete Component.options._Ctor
}
